import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';

import { NotFoundPage } from '../pages/NotFoundPage';
import { SiteFooter } from '../ui/SiteFooter';
import { SiteHeader } from '../ui/SiteHeader';
import { SkipLink } from '../ui/SkipLink';

import type { RouterContext } from '../router-context';

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: NotFoundPage,
});

function RootLayout() {
  return (
    <div className="flex min-h-dvh flex-col">
      <SkipLink />
      <SiteHeader />
      <main id="main" tabIndex={-1} className="mx-auto w-full max-w-2xl flex-1 px-4 py-8 sm:py-12">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
